<div class="modal fade" id="drag-to-shared-folder-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" [ngStyle]="{'display': showChangeAccessModal ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5>Change who has access?</h5>
        <button type="button" class="close btn-pos" data-dismiss="modal" (click)="confirmFileOperation(false)">
          <span class="NeueFile_Cancel"></span><span class="esc">esc</span>
        </button>
      </div>
      <div class="modal-body">
        @if (totalFiles == 1) {
          <p>This item will be visible to everyone who can see <strong>{{folderName}}</strong> Folder</p>
        }
        @if (totalFiles > 1) {
          <p>These items will be visible to everyone who can see <strong>{{folderName}}</strong> Folder</p>
        }
      </div>
      <div class="modal-footer border-top-0">
        <div class="btn-wrap">
          <button class="btn-cancel" data-dismiss="modal" id="btn-cancel" (click)="confirmFileOperation(false)">Cancel</button>
          <button class="btn-confirm" id="btn-confirm" (click)="confirmFileOperation(true)">{{btnName}}</button>
        </div>
      </div>
    </div>
  </div>
</div>